'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/CaretLeft.es.js";
const t = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...o, weights: a$1 }));
t.displayName = "CaretLeftIcon";
const s = t;
export {
  s as CaretLeft,
  t as CaretLeftIcon
};
